import * as React from 'react';
import { Translate } from '../../../../../shared/LanguageService';
import { IOrderRow, OrderTypes } from '../Types';
import { ButtonToolbar, Button, Popover, OverlayTrigger, ButtonGroup } from 'react-bootstrap';
import ConfirmationModal from '../../../../../components/common/ConfirmationModal';
import * as Features from '../../../../../shared/Features';
import BasicOrderInfoApi from '../BasicOrderInfoApi';

interface IProps {
    orderType: OrderTypes;
    orderRow: IOrderRow;
    orderId: number;
    key: number;
    remove: (orderRow: IOrderRow) => void;
    edit: (id: number) => void;
    user: any;
}

class OrderRow extends React.Component<IProps, any> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            showDeleteConfirmModal: false,
            includeFileRemovalWarning: false
        };
    }

    invoiceCommentPopover() {
        return (
            <Popover
                id="popover-positioned-top"
                title={Translate('view-order/basic-order-info/products/comment-headings/invoice')}
            >
                {this.props.orderRow.invoiceComment}
            </Popover>
        );
    }

    photographerCommentPopover() {
        return (
            <Popover
                id="popover-positioned-bottom"
                title={Translate(
                    'view-order/basic-order-info/products/comment-headings/photographer'
                )}
            >
                {this.props.orderRow.photographerComment}
            </Popover>
        );
    }

    toggleDeleteConfirmation() {
        let newStatus = !this.state.showDeleteConfirmModal;

        if (newStatus === true) {
            BasicOrderInfoApi.getOrderRowDeleteStatus(
                this.props.orderId,
                this.props.orderRow.id
            ).then((response) => {
                this.setState({
                    showDeleteConfirmModal: newStatus,
                    includeFileRemovalWarning: response.operationWillCauseFilesToBeRemoved
                });
            });
        } else {
            this.setState({
                showDeleteConfirmModal: newStatus,
                includeFileRemovalWarning: false
            });
        }
    }

    getDeleteText() {
        if (this.state.includeFileRemovalWarning) {
            return (
                <p>
                    <i className="material-icons">warning</i>{' '}
                    {Translate(
                        'view-order/basic-order-info/products/delete-confirmation-with-files'
                    )}
                </p>
            );
        }
        return (
            <p>
                <span>{Translate('view-order/basic-order-info/products/delete-confirmation')}</span>
            </p>
        );
    }

    render() {
        return (
            <tr>
                <td className={this.props.orderRow.removed ? 'disabled' : ''}>
                    {this.props.orderRow.productName}
                </td>
                {(this.props.orderType & OrderTypes.photo) > 0 &&
                    this.props.orderRow &&
                    this.props.orderRow.changeStatus && (
                        <td className={this.props.orderRow.removed ? 'disabled' : ''}>
                            {this.props.orderRow.changeStatus.value !== 0 && (
                                <span className="orderrow-change-status-label">
                                    {Translate(this.props.orderRow.changeStatus.displayName)}
                                </span>
                            )}
                        </td>
                    )}
                {Features.hasFeature(Features.ViewProductPriceBrokerFirm, this.props.user) && (
                    <td
                        className={
                            this.props.orderRow.removed ? 'disabled text-center' : 'text-center'
                        }
                    >
                        {this.props.orderRow.productPriceBrokerFirm}
                    </td>
                )}
                {Features.hasFeature(Features.ViewPhotographerCompensation, this.props.user) &&
                    (this.props.orderType & OrderTypes.photo) > 0 && (
                        <td
                            className={
                                this.props.orderRow.removed ? 'disabled text-center' : 'text-center'
                            }
                        >
                            {this.props.orderRow.photographerCompensation}
                        </td>
                    )}
                {Features.hasFeature(Features.ProductPricePropertyOwner, this.props.user) && (
                    <td
                        className={
                            this.props.orderRow.removed ? 'disabled text-center' : 'text-center'
                        }
                    >
                        {this.props.orderRow.productPricePropertyOwner}
                    </td>
                )}
                <td
                    className={this.props.orderRow.removed ? 'disabled text-center' : 'text-center'}
                >
                    {this.props.orderRow.quantity}
                </td>
                <td
                    className={this.props.orderRow.removed ? 'disabled text-center' : 'text-center'}
                >
                    {this.props.orderRow.invoiceStatus
                        ? Translate(this.props.orderRow.invoiceStatus.displayName)
                        : ''}
                </td>
                {(Features.hasFeature(Features.ViewInvoiceComment, this.props.user) ||
                    Features.hasFeature(Features.ViewPhotographerComment, this.props.user)) && (
                    <td
                        className={
                            this.props.orderRow.removed ? 'disabled text-center' : 'text-center'
                        }
                    >
                        <ButtonGroup className="center" disabled={this.props.orderRow.removed}>
                            {Features.hasFeature(Features.ViewInvoiceComment, this.props.user) && (
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="top"
                                    overlay={this.invoiceCommentPopover()}
                                >
                                    <Button disabled={this.props.orderRow.removed}>
                                        <i className="material-icons md-18 icon-only">
                                            attach_money
                                        </i>
                                    </Button>
                                </OverlayTrigger>
                            )}
                            {Features.hasFeature(
                                Features.ViewPhotographerComment,
                                this.props.user
                            ) && (
                                <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={this.photographerCommentPopover()}
                                >
                                    <Button disabled={this.props.orderRow.removed}>
                                        <i className="material-icons md-18 icon-only">
                                            photo_camera
                                        </i>
                                    </Button>
                                </OverlayTrigger>
                            )}
                        </ButtonGroup>
                    </td>
                )}
                <td className={this.props.orderRow.removed ? 'disabled' : ''}>
                    <ButtonToolbar className="right">
                        <ButtonGroup bsStyle="sm">
                            {Features.hasFeature(Features.ChangeOrderRow, this.props.user) && (
                                <Button
                                    onClick={() => this.props.edit(this.props.orderRow.id)}
                                    disabled={
                                        this.props.orderRow.removed ||
                                        !this.props.orderRow.canChange
                                    }
                                    bsStyle="primary"
                                >
                                    <i className="material-icons md-18">edit</i>
                                    {Translate(
                                        'view-order/basic-order-info/products/button-labels/edit'
                                    )}
                                </Button>
                            )}
                            {Features.hasFeature(Features.ChangeOrderRow, this.props.user) && (
                                <Button
                                    disabled={
                                        this.props.orderRow.removed ||
                                        !this.props.orderRow.canRemove
                                    }
                                    bsStyle="danger"
                                    onClick={() => this.toggleDeleteConfirmation()}
                                >
                                    <i className="material-icons">delete</i>
                                    {Translate('delete/button-label/delete')}

                                    {this.state.showDeleteConfirmModal && (
                                        <ConfirmationModal
                                            closeModal={() => this.toggleDeleteConfirmation()}
                                            title={Translate('delete/modal/title/delete')}
                                            text={this.getDeleteText()}
                                            doButtonLabel={Translate(
                                                'delete/modal/footer/button-label/delete'
                                            )}
                                            cancelButtonLabel={Translate(
                                                'delete/modal/footer/button-label/cancel'
                                            )}
                                            doButtonStyle="danger"
                                            do={() => this.props.remove(this.props.orderRow)}
                                            disableSubmit={true}
                                            initialSubmitDisabling={false}
                                        />
                                    )}
                                </Button>
                            )}
                        </ButtonGroup>
                    </ButtonToolbar>
                </td>
            </tr>
        );
    }
}

export default OrderRow;
